<template>
  <PrmTabMenu
    :active-index="activeTabIndex"
    :model="(visibleTabs as MenuItem[])"
    class="tab-view-menu"
    @tab-change="onTabSelect($event.index)"
  >
    <template
      #itemicon="{
        item,
      }"
    >
      <i
        v-if="typeof item.icon === 'string'"
        :class="item.icon"
        class="icon"
      />
      <component
        :is="item.icon"
        v-else
        class="icon"
      />
    </template>
  </PrmTabMenu>
</template>

<script setup lang="ts" generic="KEY extends string">
// @NitrexGroup/primevue/menuitem ships types only. A value import makes Vite's
// dependency scanner fail to resolve it, which aborts the scan for the whole project.
import type {
  MenuItem,
} from '@NitrexGroup/primevue/menuitem';
import PrmTabMenu from '@NitrexGroup/primevue/tabmenu';
import {
  computed,
} from 'vue';

import {
  TabViewItem,
} from './tab-view';

const props = defineProps<{
  activeKey: KEY | undefined,
  tabs: TabViewItem<KEY>[],
}>();

const emit = defineEmits<{
  (e: 'update:active-key', value: KEY | undefined): void,
}>();

const visibleTabs = computed(() =>
  props.tabs.filter((tab) => tab.visible !== false),
);

const activeTabIndex = computed<number | undefined>(() => visibleTabs.value.findIndex((item) => item.key === props.activeKey));

function onTabSelect(tabIndex: number) {
  emit('update:active-key', visibleTabs.value[tabIndex]?.key);
}

</script>

<style scoped lang="scss">
.tab-view-menu {
  .icon {
    margin-right: 0.5rem;
  }

  svg {
    width: 1rem;
    height: 1rem;
  }
}
</style>
